import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
  public languagesAvailable: Array<any> = [];
  constructor(public languageService: LanguageService,) {
    this.languagesAvailable = ['es', 'en']
  }

  ngOnInit() { }

  returnFlag(language) {
    switch (language) {
      case 'es':
        return 'es';

      case 'en':
        return 'us';

      default:
        break;
    }
  }

  setLanguage(language) {
    this.languageService.setLanguage(language);
  }

}
